<iframe
    sandbox="allow-scripts allow-same-origin allow-forms"
    scrolling="yes"
    width="100%"
    height="100%"
    *ngIf="archivedBetsUrl"
    [src]="archivedBetsUrl">
</iframe>
